import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";

const ALLOWED_PARENT_ORIGINS = new Set([
  "https://hr-qa-crm.crm4.dynamics.com",
  "https://hr-p-crm.crm4.dynamics.com",
  "http://localhost:3000",
  "http://localhost:56348",
]);

export function usePreviewBridge() {
  const [searchParams] = useSearchParams();
  const channelId = searchParams.get("channelId") || "";
  const [payload, setPayload] = useState(null);

  const parentOrigin = useMemo(() => {
    try {
      return new URL(document.referrer).origin;
    } catch {
      return "";
    }
  }, []);

  useEffect(() => {
    if (!channelId) return;

    function onMessage(event) {
      if (!ALLOWED_PARENT_ORIGINS.has(event.origin)) return;

      const d = event.data;
      if (!d || d.app !== "PreviewBridge" || d.version !== 1) return;
      if (d.channelId !== channelId) return;

      if (d.type === "PAYLOAD") {
        setPayload(d.payload || null);

        event.source?.postMessage(
          { app: "PreviewBridge", version: 1, channelId, type: "ACK" },
          event.origin
        );
      }
    }

    window.addEventListener("message", onMessage);

    if (ALLOWED_PARENT_ORIGINS.has(parentOrigin)) {
      window.opener?.postMessage(
        { app: "PreviewBridge", version: 1, channelId, type: "READY" },
        parentOrigin
      );
    } else {
      for (const origin of ALLOWED_PARENT_ORIGINS) {
        window.opener?.postMessage(
          { app: "PreviewBridge", version: 1, channelId, type: "READY" },
          origin
        );
      }
    }

    return () => window.removeEventListener("message", onMessage);
  }, [channelId, parentOrigin]);

  return payload;
}
